import { FC } from 'react';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Button,
} from '@chakra-ui/react';
import { PlaylistAudioCreditsTable } from './PlaylistAudioCreditsTable';
import { Contribution } from '../ReadOnlyPlaylist/types';

export interface PlaylistAudioCreditsDialogProps {
  open: boolean;
  onClose: () => void;
  onContactCardOpen?: () => void;
  subTitle?: string;
  credits?: Contribution[];
}

export const PlaylistAudioCreditsDialog: FC<PlaylistAudioCreditsDialogProps> = ({
  open,
  onClose,
  onContactCardOpen = () => {},
  subTitle,
  credits = [],
}) => {
  const title = 'Credits';
  return (
    <Modal isOpen={open} onClose={onClose} data-testid="dialog" size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader data-testid="dialog-title" title={title}>
          {title}
          {subTitle && (
            <Text
              color="textSubdued"
              textOverflow="ellipsis"
              overflow="hidden"
              title={subTitle}
            >
              {subTitle}
            </Text>
          )}
        </ModalHeader>
        <ModalBody
          data-testid="dialog-content"
          maxHeight="300px"
          overflowY="auto"
        >
          {credits.length > 0 ? (
            <PlaylistAudioCreditsTable
              credits={credits}
              onContactCardOpen={onContactCardOpen}
            />
          ) : (
            <Text color="textSubdued" textAlign="center">
              {`This song doesn't have any credits yet.`}
            </Text>
          )}
        </ModalBody>
        <ModalFooter data-testid="dialog-actions">
          <Button onClick={onClose}>Done</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
